import { BooleanFormType } from "Store/interfaces/FormTypes";
import { isDefined } from "Utils/functions";

export const hasDamageFromPests = (
  pestsDamaged: BooleanFormType | undefined,
): boolean => isDefined(pestsDamaged) && pestsDamaged === BooleanFormType.TRUE;

export const negativeMaintenanceConfirmation = (
  maintenanceConfirmation: BooleanFormType,
): boolean => maintenanceConfirmation === BooleanFormType.FALSE;

export const hasHistoryOfWaterOrMoistureDamage = (
  isWithHistoryOfWaterOrMoistureDamage: BooleanFormType | undefined,
): boolean =>
  isDefined(isWithHistoryOfWaterOrMoistureDamage) &&
  isWithHistoryOfWaterOrMoistureDamage === BooleanFormType.TRUE;
